import { render, staticRenderFns } from "./VariantDefaultCreativeColumn.vue?vue&type=template&id=fef19176&"
import script from "./VariantDefaultCreativeColumn.vue?vue&type=script&lang=js&"
export * from "./VariantDefaultCreativeColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports